import React, { FC } from 'react'
import * as Styled from './styled'
import * as CommonStyled from '../styled'
import { AnalyticsPageEventInfo, AnalyticsTrackEventInfo, ProductWizardStepProps, WizardOptions } from '../types'
import { useDidMount } from '../../../hooks'
import { DuckFootStepNameForAnalytics } from './types'

type PropsType = {
  opened: boolean
  handleStepMake: (id: string, name: string) => void
  getProducers: () => ProductWizardStepProps[] | []
  onSendAnalyticsPage?: (info: AnalyticsPageEventInfo) => void
  onSendAnalyticsTrack?: (info: AnalyticsTrackEventInfo) => void
}

export const DuckFootMake: FC<PropsType> = ({
  opened,
  handleStepMake,
  getProducers,
  onSendAnalyticsPage,
  onSendAnalyticsTrack,
}) => {
  const producers = getProducers()
  const renderProducersListJSX = producers.map(producer => {
    const options = producer?.options as WizardOptions
    return (
      <Styled.ProductWizardMakeItem
        data-test-id={producer.id}
        title={producer.title}
        onClick={() => {
          handleStepMake(producer.id, producer.title)
          onSendAnalyticsTrack?.({
            step: DuckFootStepNameForAnalytics.ChooseMake,
            choice: producer.title,
          })
        }}
        key={producer.id}
      >
        <Styled.LogoContainer>{options.url && <Styled.LogoImg src={options.url} />}</Styled.LogoContainer>
        {producer.title}
      </Styled.ProductWizardMakeItem>
    )
  })

  useDidMount(() => {
    // this 'if' is here because the DuckFootMake re-renders after closing the wizard
    if (opened) {
      onSendAnalyticsPage?.({ step: DuckFootStepNameForAnalytics.ChooseMake })
    }
  })
  return <CommonStyled.ProductWizardWrapper>{renderProducersListJSX}</CommonStyled.ProductWizardWrapper>
}
